export default "__VITE_ASSET__CQ26fKxs__"